import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Configuracoes from './pages/Configuracoes';
import Usuarios from './pages/Usuarios';
import UsuarioDetalhe from './pages/UsuarioDetalhe';
import Listas from './pages/Listas';
import Logs from './pages/Logs';
import Campanhas from './pages/Campanhas';
import Chat from './pages/Chat';
import Evolution from './pages/Evolution';
import Login from './pages/Login';
import Assinaturas from './pages/Assinaturas';
import GerenciarUsuarios from './pages/GerenciarUsuarios';
import Vendas from './pages/Vendas';
import Comissoes from './pages/Comissoes';
import ConfiguracaoComissoes from './pages/ConfiguracaoComissoes';
import MetaFunil from './pages/MetaFunil';
import Atendimento from './pages/Atendimento';
import PainelAtendimento from './pages/PainelAtendimento';
import RelatorioAtendimento from './pages/RelatorioAtendimento';
import Estatisticas from './pages/Estatisticas';
import EstatisticasChats from './pages/EstatisticasChats';
import EstatisticasVendas from './pages/EstatisticasVendas';
import EstatisticasProdutividade from './pages/EstatisticasProdutividade';
import Tarefas from './pages/Tarefas';
import EmailTemplates from './pages/EmailTemplates';
import CampanhasEmail from './pages/CampanhasEmail';
import CampaignSegments from './pages/CampaignSegments';
import SMTPConfigs from './pages/SMTPConfigs';
import BulkEmailCampaigns from './pages/BulkEmailCampaigns';
import EmailWorkflows from './pages/EmailWorkflows';
import EmailTags from './pages/EmailTags';
import Checkout from './pages/Checkout';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutError from './pages/CheckoutError';
import Invoices from './pages/Invoices';
import { useNotifications } from './hooks/useNotifications';
import ToastContainer, { useToast } from './components/ToastContainer';

function AppContent() {
  const location = useLocation();
  const isLoginPage = location.pathname === '/login';
  const [notificationCount, setNotificationCount] = useState(0);
  const { toasts, addToast, removeToast } = useToast();

  // Ativar notificações apenas quando não estiver na página de login
  const { isConnected } = useNotifications({
    enabled: !isLoginPage,
    onNewMessage: (notification) => {
      console.log('🔔 Nova mensagem recebida:', notification);
      setNotificationCount(prev => prev + 1);
      
      // Atualizar título da página com contador
      if (document.hidden) {
        document.title = `(${notificationCount + 1}) Nova mensagem - CRM`;
      }
    },
    onShowToast: (data) => {
      // Adicionar toast visual
      addToast({
        title: 'Nova Mensagem',
        message: data.message,
        userName: data.userName,
        userId: data.userId,
        duration: 10000
      });
    }
  });

  // Resetar título quando a página ficar visível
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        document.title = 'CRM - Braziliana Shop';
        setNotificationCount(0);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  // Mostrar status de conexão no console
  useEffect(() => {
    if (!isLoginPage) {
      console.log(`🔌 Status de conexão SSE: ${isConnected ? 'Conectado' : 'Desconectado'}`);
    }
  }, [isConnected, isLoginPage]);

  return (
    <>
      {/* Container de Toasts */}
      <ToastContainer toasts={toasts} onRemoveToast={removeToast} />
      
      <Routes>
      <Route path="/login" element={<Login />} />
      
      {/* Rotas públicas de checkout */}
      <Route path="/checkout/:token" element={<Checkout />} />
      <Route path="/checkout-success/:token" element={<CheckoutSuccess />} />
      <Route path="/checkout-error/:token" element={<CheckoutError />} />
      
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout onLogout={() => {
              localStorage.removeItem('token');
              localStorage.removeItem('user');
              window.location.href = '/login';
            }}>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="configuracoes" element={<Configuracoes />} />
                <Route path="usuarios" element={<Usuarios />} />
                <Route path="usuarios/:id" element={<UsuarioDetalhe />} />
                <Route path="listas" element={<Listas />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="vendas" element={<Vendas />} />
                <Route path="comissoes" element={<Comissoes />} />
                <Route path="configuracao-comissoes" element={<ConfiguracaoComissoes />} />
                <Route path="meta-funil" element={<MetaFunil />} />
                <Route path="atendimento" element={<Atendimento />} />
                <Route path="painel-atendimento" element={<PainelAtendimento />} />
                <Route path="relatorio-atendimento" element={<RelatorioAtendimento />} />
                <Route path="estatisticas" element={<Estatisticas />} />
                <Route path="estatisticas-chats" element={<EstatisticasChats />} />
                <Route path="estatisticas-vendas" element={<EstatisticasVendas />} />
                <Route path="estatisticas-produtividade" element={<EstatisticasProdutividade />} />
                <Route path="tarefas" element={<Tarefas />} />
                <Route path="email-templates" element={<EmailTemplates />} />
                <Route path="campaign-segments" element={<CampaignSegments />} />
                <Route path="campanhas-email" element={<CampanhasEmail />} />
                <Route path="smtp-configs" element={<SMTPConfigs />} />
                <Route path="bulk-email-campaigns" element={<BulkEmailCampaigns />} />
                <Route path="email-workflows" element={<EmailWorkflows />} />
                <Route path="email-tags" element={<EmailTags />} />
                <Route path="logs" element={<Logs />} />
                <Route path="campanhas" element={<Campanhas />} />
                <Route path="chat" element={<Chat />} />
                <Route path="evolution" element={<Evolution />} />
                <Route path="assinaturas" element={<Assinaturas />} />
                <Route path="gerenciar-usuarios" element={<GerenciarUsuarios />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;